// src/data/datasets.js
export const DATASETS = [
  { id: "POLE",   label: "POLE",   nodes: 61521,     edges: 105840 },
  { id: "MB6",    label: "MB6",    nodes: 486267,    edges: 961571 },
  { id: "HETIO",  label: "HET.IO", nodes: 47031,     edges: 2250197 },
  { id: "FIB25",  label: "FIB25",  nodes: 802473,    edges: 1625428 },
  { id: "ICIJ",   label: "ICIJ",   nodes: 2016523,   edges: 3339267 },
  { id: "LDBC",   label: "LDBC",   nodes: 3181724,   edges: 17256038 },
  { id: "CORD19", label: "CORD19",nodes: 36025729,  edges: 59768373 },
  { id: "IYP",    label: "IYP",    nodes: 44539999,  edges: 251432812 },
];

export const datasetById = Object.fromEntries(DATASETS.map(d => [d.id, d]));
